import Vue from 'vue';
import App from './App.vue';

import { AppConfig } from '@config';

/**
 * Loading Vue plugins for usage.
 */
import router from './router';
import store from './store';
import xhr from './xhr';

/**
 * Directives
 */
import './directives/click-outside';
import "./filters"

import Page from '@classes/Page';

/**
 * Control your routing with the beforeEach event.
 * For example. Check here if a user is logged in and redirect the user to the correct page.
 */
router.beforeEach(Page.controlRouting);

/**
 * Adding xhr to the vuex store. Your ServerRequest is available in the variabele this.$xhr in your store.
 */
store.$xhr = xhr.getInstance();

xhr.getInstance().get('/sanctum/csrf-cookie/').then(r => console.log('CSRF Cookie geladen'));

/**
 * Creating vue instance.
 * Available plugins in your vue component:
 * - $router
 * - $route
 * - $store
 * - $socket
 * - $xhr
 *
 * @type {Vue}
 */
const app = new Vue({
    router,
    store,
    xhr,
    render: h => h(App)
}).$mount(AppConfig.mount || '#application');
